import { AVAILABLE_LANGUAGES } from '@/constants';
import { SylndrHelpPoint } from '../sylndr-help.types';
import { Dispatch, SetStateAction } from 'react';
import { SylndrHelpBottomSheet } from './sylndr-help-bottomsheet';
import { SylndrHelpModal } from './sylndr-help-modal';
import { gradientColors } from '../../constants';
import { CarTypesEnum } from '@/components/car-details-v2/car-type';

export const SylndrHelpContent = ({
    section,
    lang,
    openContent,
    setOpenContent,
    IS_DESKTOP,
    inspectionRef,
}: {
    section: SylndrHelpPoint;
    lang: AVAILABLE_LANGUAGES;
    openContent: boolean;
    setOpenContent: Dispatch<SetStateAction<boolean>>;
    IS_DESKTOP: boolean;
    inspectionRef: React.RefObject<HTMLDivElement>;
}) => {
    const gradientColor = gradientColors(CarTypesEnum.Dealer);
    return (
        <>
            {IS_DESKTOP ? (
                <SylndrHelpModal
                    openModal={openContent}
                    setOpenModal={setOpenContent}
                    lang={lang}
                    gradientColor={gradientColor}
                    section={section}
                />
            ) : (
                <SylndrHelpBottomSheet
                    openBottomSheet={openContent}
                    setOpenBottomSheet={setOpenContent}
                    lang={lang}
                    section={section}
                    inspectionRef={inspectionRef}
                />
            )}
        </>
    );
};
